// extracted by mini-css-extract-plugin
export var product = "ourProduct-module--product--I67RZ";
export var productBg = "ourProduct-module--productBg--M3aRc";
export var productTimeline = "ourProduct-module--productTimeline--xy8Jd";
export var productText = "ourProduct-module--productText--+tOc4";
export var productPanel = "ourProduct-module--productPanel--swyMR";
export var ShowPage = "ourProduct-module--ShowPage--00Vun";